import { render, staticRenderFns } from "./singleWordDetail.vue?vue&type=template&id=160b969e&"
import script from "./singleWordDetail.vue?vue&type=script&lang=js&"
export * from "./singleWordDetail.vue?vue&type=script&lang=js&"
import style0 from "./singleWordDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports